"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class ControllerCompositionGisAreas {
    constructor(gisAreas) {
        this.dataSynthetic = {
            crop: {
                id: 0,
                crop_name: '',
                logo_name: '',
                color: '',
            },
            agreage: {
                value: 0,
                unit: '',
            },
            valid_date: '',
            score: 0,
        };
        this.gisAreas = gisAreas || [];
    }
    scoreMedia(scores) {
        if (scores.length === 0) {
            return 0;
        }
        let suma = 0;
        for (let i = 0; i < scores.length; i++) {
            suma += scores[i];
        }
        const media = suma / scores.length;
        return media;
    }
    parseFecha(fechaStr) {
        const partes = fechaStr.split(' ');
        const fecha = partes[0];
        const hora = partes[1] || '00:00:00';
        return new Date(`${fecha}T${hora}`);
    }
    findObjectWithHighestYear() {
        console.log(this.gisAreas, 'fff');
        if (this.gisAreas.length > 0) {
            const objetoFechaMasBaja = this.gisAreas.reduce((anterior, actual) => {
                const fechaAnterior = this.parseFecha(anterior.due_date);
                const fechaActual = this.parseFecha(actual.due_date);
                return fechaAnterior > fechaActual ? actual : anterior;
            });
            const fechaAntigua = new Date(objetoFechaMasBaja.due_date);
            fechaAntigua.setFullYear(fechaAntigua.getFullYear() + 1);
            console.log(fechaAntigua, 'antigua');
            const año = fechaAntigua.getFullYear();
            const mes = fechaAntigua.getMonth() + 1; // +1 porque los meses en JavaScript van de 0 a 11
            const dia = fechaAntigua.getDate();
            const fechaFormateada = `${año}-${mes}-${dia}`;
            return fechaFormateada;
        }
        else {
            return '';
        }
    }
    acresToHectares(acres) {
        const conversionFactor = 0.404686;
        const hectares = acres * conversionFactor;
        return hectares;
    }
    composeDataSynthetic() {
        var _a, _b, _c;
        let agreage = 0;
        const scores = [];
        this.dataSynthetic.crop.id = (_a = this.gisAreas[0]) === null || _a === void 0 ? void 0 : _a.crop.id;
        this.dataSynthetic.crop.crop_name = (_b = this.gisAreas[0]) === null || _b === void 0 ? void 0 : _b.crop.crop_name;
        this.dataSynthetic.crop.logo_name = (_c = this.gisAreas[0]) === null || _c === void 0 ? void 0 : _c.crop.logo_name;
        this.dataSynthetic.agreage.unit = 'hectares';
        this.dataSynthetic.valid_date = this.findObjectWithHighestYear();
        console.log(this.findObjectWithHighestYear());
        for (const area of this.gisAreas) {
            if (area.acreage.unit === 'acres') {
                agreage += this.acresToHectares(area.acreage.value);
            }
            else {
                agreage += area.acreage.value;
            }
            scores.push(area.score);
        }
        this.dataSynthetic.agreage.value = agreage;
        this.dataSynthetic.score = this.scoreMedia(scores);
    }
    get getDataSynthetic() {
        return this.dataSynthetic;
    }
}
exports.default = ControllerCompositionGisAreas;
